<template>
  <div>
    <el-container direction="vertical" class="layout-container">
      <HEAD :active="active"></HEAD>
      <el-main class="el-main-ms">
        <el-page-header @back="goBack" content="媒体中心" style="margin: 20px"></el-page-header>
        <div style="text-align: left;text-align: left;width: 85%;display: inline-block;">
          <news-plugin></news-plugin>
        </div>
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
      <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import ContactPlugin from "@/components/ContactPlugin";
import NewsPlugin from "@/components/NewsPlugin";
export default {
  name: "News",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '陌上媒体中心'
    },{
      name: 'description',
      content: '陌上酒店-媒体中心'
    }]
  },
  data() {
    return {
      active: '1',
      imgSrc: require('../assets/images/mspp-pgcs.png')
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/' })
    }
  },
  components: {
    HEAD,
    FOOT,
    ContactPlugin,
    NewsPlugin
  }
}
</script>

<style scoped>
  .ab-title {
    font-size: 20px;
    font-weight: 550;
  }
</style>

